import React, { useState, useRef, useEffect } from "react";

import { useDebouncedCallback, useDebounce } from "use-debounce";
const debouncetime = 600;

import { api } from "./pureFunctions";
import { header, host } from "./globalVariables";
import { Link } from "react-router";

export default function SearchEstate({}) {
   const [results, setResults] = useState([]);
   const [searchHistory, setSearchHistory] = useState(() => {
      let storageHistory = localStorage.getItem("searchhistory")
         ? JSON.parse(localStorage.getItem("searchhistory"))
         : [];
      storageHistory.length = storageHistory.length > 10 ? 10 : storageHistory.length;
      return storageHistory;
   });
   const [searchValue, setSearchValue] = useState("");
   const [show, setShow] = useState(false);
   //    const [debouncedValue] = useDebounce(searchValue, 1000);

   const debounced = useDebouncedCallback(
      // function
      (value) => {
         getSearchResults(value);
      },
      // delay in ms
      debouncetime,
   );

   async function getSearchResults(value) {
      console.log(value);
      if (value.length > 2) {
         await api.post("/api/searchEstates", { value }, header).then((data) => {
            console.log(data);
            setResults(data.data);
         });
      } else {
         setResults([]);
      }
   }

   const wrapperRef = useRef(null);

   useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
         if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setShow(false);
         }
      }
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
         // Unbind the event listener on clean up
         document.removeEventListener("mousedown", handleClickOutside);
      };
   }, [wrapperRef]);

   function numberToNiceColor(n) {
      const hue = (Math.imul(n | 0, 2654435761) >>> 0) % 360;
      return `hsla(${hue}, 65%, 55%, 0.7)`;
   }

   function handleResultClick(result) {
      const newSearchHistory = structuredClone(searchHistory).filter((item) => item.id !== result.id);
      if (newSearchHistory.length >= 10) newSearchHistory.pop();
      newSearchHistory.unshift(result);
      localStorage.setItem("searchhistory", JSON.stringify(newSearchHistory));
      setSearchHistory(newSearchHistory);
      setResults([]);
      setSearchValue("");
      setShow(false);
   }

   return (
      <div className="nav-search">
         <input
            type="text"
            value={searchValue}
            onClick={() => setShow(true)}
            /* onChange={(e) => setSearchValue(e.target.value)} */ onChange={(e) => {
               setSearchValue(e.target.value);
               debounced(e.target.value);
            }}
         />
         {
            /* results.length > 0 && */ show && (
               <div ref={wrapperRef}>
                  <ul style={{ color: "#000", background: "#fff", zIndex: 100000 }}>
                     {results.map((result, index) => {
                        return (
                           <li
                              key={"search_" + index}
                              style={{
                                 backgroundColor: `${numberToNiceColor(parseInt(result.elements.objektnr_extern))}`,
                              }}
                           >
                              <Link
                                 to={"/datenblatt?estateid=" + result.id}
                                 onClick={() => {
                                    handleResultClick(result);
                                 }}
                              >
                                 <strong>{result.elements.objektnr_extern}</strong>{" "}
                                 <small>
                                    {result.elements?.ind_3274_Feld_ObjIndividualCategoryFields281?.slice(0, -5)}
                                 </small>
                              </Link>
                           </li>
                        );
                     })}
                     <li style={{ backgroundColor: "#333", color: "#fff" }}>--- Suchverlauf ---</li>
                     {searchHistory.map((result, index) => {
                        return (
                           <li
                              key={"searchhistory_" + index}
                              style={{
                                 backgroundColor: `${numberToNiceColor(parseInt(result.elements.objektnr_extern))}`,
                              }}
                           >
                              <Link
                                 to={"/datenblatt?estateid=" + result.id}
                                 onClick={() => {
                                    handleResultClick(result);
                                 }}
                              >
                                 <strong>{result.elements.objektnr_extern}</strong>{" "}
                                 <small>
                                    {result.elements?.ind_3274_Feld_ObjIndividualCategoryFields281?.slice(0, -5)}
                                 </small>
                              </Link>
                           </li>
                        );
                     })}
                  </ul>
               </div>
            )
         }
      </div>
   );
}
